<div class="w-100 h-100 d-flex justify-content-center align-items-center flex-column" 
    *ngIf="this.getType() === OtpType.Default || this.getType() == null || 
        this.getType() == undefined || this.getType().toString() === ''">

    <!-- contact -->
    <div *ngIf="this.getContactVerify()" class="contact-container">
        <span class="bs-paragraph th-text-dark-gray text-center fw-bold">{{this.contactVerifyMasked}}</span>
    </div>

    <!-- otp code -->
    <div class="d-flex justify-content-center align-items-center gap-2"> 
        <div *ngFor="let input of otpFields; let i=index" class="d-flex otp-input-container position-relative">
            <input #otpInput
                   type="text" 
                   maxlength="1" 
                   [id]="'otp_input_'+number" 
                   placeholder="-"
                   [disabled]="!this.getContactVerify()"
                   class="w-100 h-100 otp-input text-center"
                   (input)="moveFocus($event, i)">
        </div>
    </div>

    <!-- resend code -->
    <div class="resend-code-line th-bg-border-line-background"></div>

    <div class="mb-2">
        <span class="th-text-main bs-paragraph">¿No recibió el código?</span>
    </div>

    <div class="d-flex justify-content-center align-items-center flex-column">
        <span class="th-text-main bs-button resend-container"
              [ngClass]="{
                'resend-container-locked' : this.isButtonLocked || !this.getContactVerify()
              }"
              (click)="sendCode()">
        Reenviar
        </span>
        <span class="th-text-main bs-button timer-container" *ngIf="this.isButtonLocked">
            {{this.timeDisplay}}
        </span>
    </div>

    <div class="error-message-container">
        <ng-container #errorMessageContainer></ng-container>
    </div>
</div>
<!-- Mini format -->
<div *ngIf="this.getType() === OtpType.Mini">
    <div class="w-100 th-bg-white th-line p-3 mini-otp-container">
        <h3 class="bs-h2 th-text-main">{{this.getMiniOtpTitle()}}</h3>
        <hr class="th-bg-border-line-background m-0 mb-3">
        <span class="bs-paragraph th-text-gray-paragraphs">{{this.getMiniOtpDescription()}}</span>
        <div class="d-flex">
            <ng-container #miniOtpContainer></ng-container>
        </div>
        <ng-container #miniOtpButton></ng-container>
        <div *ngIf="this.isMiniOtpCodeSectionOpen">
            <hr class="th-bg-border-line-background m-0 mb-3 mt-3">
            <span class="bs-paragraph th-text-gray-paragraphs">{{this.getMiniOtpSendMessage()}}</span>
            <div class="d-flex mt-3">
                <div class="enter-code-input">
                    <input type="text" 
                           (input)="this.onMiniOtpChange($event)"
                           class="mini-otp-input th-line w-100" 
                           #miniOtp>
                </div>
                <div class="code-status-container ms-3 d-flex align-items-center justify-content-center">
                    <object [data]="this.miniOtpIcon | safeUrl"
                            type="image/svg+xml"
                            [width]="36"
                            [height]="36">
                    </object>
                </div>
            </div>
            <div *ngIf="this.miniOtpError.length > 0" class="mt-2">
                <span class="th-text-alert bs-paragraph">
                    {{this.miniOtpError}}
                </span>
            </div>
            <hr class="th-bg-border-line-background mb-3 mt-3">
            <div class="d-flex">
                <div>
                    <span class="bs-paragraph th-text-gray-paragraphs">¿No recibió el código?</span>
                </div>
                <div>
                    <span class="bs-button th-text-main resend-container ms-2"
                          [ngClass]="{
                            'resend-container-locked' : this.isButtonLocked
                          }"
                          (click)="sendCode()">
                        Reenviar
                    </span>
                </div>
                <div class="ms-auto">
                    <span class="bs-button th-text-main timer-container" 
                    *ngIf="this.isButtonLocked">
                        {{this.timeDisplay}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>